import Highcharts from "highcharts";
import gray from "highcharts/themes/gray";
import skies from "highcharts/themes/skies";

import exportingInit from "highcharts/modules/exporting";
import offlineExporting from "highcharts/modules/export-data";

exportingInit(Highcharts);
offlineExporting(Highcharts);

Highcharts.setOptions({
	lang: {
  	thousandsSep: ','
  }
})

export default {
    data() {
        return {
            highchartsExporting: {
                buttons: {
                    contextButton: {
                        menuItems: [
                            // "printChart",
                            // "separator",
                            "downloadPNG",
                            // "downloadJPEG",
                            // "downloadPDF",
                            // "downloadSVG",
                            "separator",
                            "downloadCSV",
                            "downloadXLS",
                            //"viewData",
                            //"openInCloud",
                        ],
                    },
                },
            },
        }
    },
    beforeMount() {
        if (this.$vuetify.theme.dark) {
            // gray(Highcharts);
        } else {
            // skies(Highcharts);
        }
        // must be present for post-harvest charts to render correctly
        this.refresh();
    },
}
